export default __webpack_public_path__ + "static/media/colors.3f27f00f.glsl";